import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Rambunctious Rhthyms",
  date: new Date(2024, 11, 15),
  img: "/img/cliff.jpeg",
  tracks: [
    {
      title: "Turning the Wheels",
      src: "/songs/2024-12-15/turning_the_wheels.mp3",
      duration: 728.376,
    },
    {
      title: "Can You Smell What The Rock is Cooking?",
      src: "/songs/2024-12-15/can_you_smell_what_the_rock_is_cooking.mp3",
      duration: 601.896,
    },
    {
      title: "If there's one thing that I wanna tell you",
      src: "/songs/2024-12-15/if_theres_one_thing.mp3",
      duration: 916.416,
    },
    {
      title: "Dulcit Tones",
      src: "/songs/2024-12-15/dulcit_tones.mp3",
      duration: 626.688,
    },
    {
      title: "Early Morning Sun",
      src: "/songs/2024-12-15/early_morning_sun.mp3",
      duration: 650.304,
    },
    {
      title: "Dreamscape Horizon",
      src: "/songs/2024-12-15/dreamscape_horizon.mp3",
      duration: 737.568,
    },
    {
      title: "The Ballard of Jonny Lyle",
      src: "/songs/2024-12-15/the_ballard_of_jonny_lyle.mp3",
      duration: 778.104,
    },
    {
      title: "Memphis is Where I Lay My Head",
      src: "/songs/2024-12-15/memphis_is_where_i_lay_my_head.mp3",
      duration: 2006.04,
    },
    {
      title: "Flight of The Navigator",
      src: "/songs/2024-12-15/flight_of_the_navigator.mp3",
      duration: 579.792,
    },
    {
      title: "Leatherneck Pursuit",
      src: "/songs/2024-12-15/leatherneck_pursuit.mp3",
      duration: 1969.632,
    },
    {
      title: "Bringing It Down Take 1",
      src: "/songs/2024-12-15/bringing_it_down_take_1.mp3",
      duration: 262.776,
    },
    {
      title: "Bringing It Down Take 2",
      src: "/songs/2024-12-15/bringing_it_down_take_2.mp3",
      duration: 214.44,
    },
    {
      title: "Tofurky Xmas",
      src: "/songs/2024-12-15/tofurky_xmas.mp3",
      duration: 1204.56,
    },
    {
      title: "Smooth Finish",
      src: "/songs/2024-12-15/smooth_finish.mp3",
      duration: 2192.328,
    },
  ],
};
export default album;
